import { addProp } from "@pnp/odata";
import { _Item } from "../items/types";
import { Folder } from "./types";
addProp(_Item, "folder", Folder, "folder");
//# sourceMappingURL=item.js.map